import { routergeraettyp } from '../../../../utils/apiTypes';
import { routergeraettypState } from "./routergeraettypenTypes";
import { AnyAction, createSlice, PayloadAction, ThunkAction } from "@reduxjs/toolkit";
import { getWithAuth, putWithAuth, deleteWithAuth, postJsonWithAuth } from "../../../../utils/api";
import type { RootState, AppDispatch } from "../../../../app/store";
import { logError } from "../../../../utils/utils";
import { openSnackbar } from "../../../../features/snackbar/globalSnackbarSlice";
import { GridSortModel } from '@material-ui/data-grid';
import { errorHandler } from '../../../../utils/errorHandling';

export const routergeraettypDummy: routergeraettyp
  = {
  id: 0,
  typ: "",
  hersteller: "",
  kommentar: "",
  zugeordnet: false
};

const initialState: routergeraettypState
  = {
  routergeraettypListe: [],
  altesRoutergeraettyp: routergeraettypDummy,
  aktuellesRoutergereattyp: routergeraettypDummy,
  newEntry: false,
  editEntry: false,
  editDirty: 0,
  viewMode: false,
  error: [],
  listLoading: false,
  sorting: [
    {
      field: 'hersteller',
      sort: 'asc',
    },
  ]
};

const routergeraettypenSlice = createSlice({
  name: "routergeraettyp",
  initialState,
  reducers:
  {
    updateRoutergeraettypen: (state, action: PayloadAction<routergeraettyp>) => {
      const updateIndex = state.routergeraettypListe.findIndex(
        (x: routergeraettyp) => x.id == action.payload.id
      );
      const firstPart = state.routergeraettypListe.slice(0, updateIndex);
      let lastPart = Array<routergeraettyp>();
      if (updateIndex + 1 < state.routergeraettypListe.length)
        lastPart = state.routergeraettypListe.slice(updateIndex + 1);
      state.routergeraettypListe = [...firstPart, action.payload, ...lastPart].sort((a, b) => a.typ.localeCompare(b.typ));
    },
    removeFromRoutergeraettypen: (state, action: PayloadAction<routergeraettyp>) => {
      const updateIndex = state.routergeraettypListe.findIndex(
        (x) => x.id == action.payload.id
      );
      const firstPart = state.routergeraettypListe.slice(0, updateIndex);
      let lastPart = Array<routergeraettyp>();
      if (updateIndex + 1 < state.routergeraettypListe.length)
        lastPart = state.routergeraettypListe.slice(updateIndex + 1);
      state.routergeraettypListe = [...firstPart, ...lastPart];
    },
    addAktuellesRoutergeraettypToRoutergeraettypen: (state) => {
      const routergeraettypArray = state.routergeraettypListe;
      routergeraettypArray.push(state.aktuellesRoutergereattyp);
      state.routergeraettypListe = [...routergeraettypArray].sort((a, b) => a.typ.localeCompare(b.typ));
    },
    setRoutergeraettypen: (state, action: PayloadAction<Array<routergeraettyp>>) => {
      state.routergeraettypListe = action.payload;
    },
    setIdAktuellesRoutergeraettyp: (state, action: PayloadAction<number>) => {
      state.aktuellesRoutergereattyp.id = action.payload;
    },
    setAktuellesRoutergeraettyp: (state, action: PayloadAction<routergeraettyp>) => {
      state.aktuellesRoutergereattyp = action.payload;
      state.altesRoutergeraettyp = action.payload;
    },
    setAltesRoutergeraettyp: (state, action: PayloadAction<routergeraettyp>) => {
      state.altesRoutergeraettyp = action.payload;
    },
    resetAktuellesRoutergeraettyp: (state) => {
      state.aktuellesRoutergereattyp = state.altesRoutergeraettyp;
    },
    setEditEntry: (state) => {
      state.editEntry = true;
    },
    resetEditEntry: (state) => {
      state.editEntry = false;
    },
    setNewEntry: (state) => {
      state.newEntry = true;
    },
    resetNewEntry: (state) => {
      state.newEntry = false;
    },
    resetEditDirty: (state) => {
      state.editDirty = 0;
    },
    setViewMode: (state) => {
      state.viewMode = true;
    },
    resetViewMode: (state) => {
      state.viewMode = false;
    },
    setError: (state, action: PayloadAction<string>) => {
      if (!state.error.includes(action.payload)) {
        state.error.push(action.payload);
      }
    },
    resetError: (state, action: PayloadAction<string>) => {
      if (state.error.includes(action.payload)) {
        state.error.splice(state.error.indexOf(action.payload), 1)
      }
    },
    setId: (state, action: PayloadAction<number>) => {
      state.aktuellesRoutergereattyp.id = action.payload;
      state.editDirty =
        state.aktuellesRoutergereattyp.id ==
          state.altesRoutergeraettyp.id
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setTyp: (state, action: PayloadAction<string>) => {
      state.aktuellesRoutergereattyp.typ = action.payload;
      state.editDirty =
        state.aktuellesRoutergereattyp.typ ==
          state.altesRoutergeraettyp.typ
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setHersteller: (state, action: PayloadAction<string>) => {
      state.aktuellesRoutergereattyp.hersteller = action.payload;
      state.editDirty =
        state.aktuellesRoutergereattyp.hersteller ==
          state.altesRoutergeraettyp.hersteller
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setKommentar: (state, action: PayloadAction<string>) => {
      state.aktuellesRoutergereattyp.kommentar = action.payload;
      state.editDirty =
        state.aktuellesRoutergereattyp.kommentar ==
          state.altesRoutergeraettyp.kommentar
          ? state.editDirty - 1
          : state.editDirty + 1;
    },
    setListLoading: (state, action: PayloadAction<boolean>) => {
      state.listLoading = action.payload;
    },
    setSorting: (state, action: PayloadAction<GridSortModel>) => {
      state.sorting = action.payload;
    },
  }
});


//Selectors
//======================================================================
export const selectRoutergeraettypListe = (state: RootState): Array<routergeraettyp> =>
  state.routergeraettyp.routergeraettypListe;
export const selectAktuellesRoutergeraettyp = (state: RootState): routergeraettyp =>
  state.routergeraettyp.aktuellesRoutergereattyp;
export const selectEditEntry = (state: RootState): boolean =>
  state.routergeraettyp.editEntry;
export const selectNewEntry = (state: RootState): boolean => state.routergeraettyp.newEntry;
export const selectEditDirty = (state: RootState): number =>
  state.routergeraettyp.editDirty;
export const selectViewMode = (state: RootState): boolean => state.routergeraettyp.viewMode;
export const selectError = (state: RootState): boolean => state.routergeraettyp.error.length > 0;
export const selectListLoading = (state: RootState): boolean => state.routergeraettyp.listLoading;
export const selectSorting = (state: RootState): GridSortModel => state.routergeraettyp.sorting;

//Actions
//=====================================================================

export const getRoutergeraettypen = () => (dispatch: AppDispatch): void => {
  dispatch(setListLoading(true));
  getWithAuth("ROUTERTYP", {})
    .then((response) => {
      dispatch(setRoutergeraettypen(response));
    })
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));
};

export const updateRoutergeraettyp = (aktuellesRoutergeraettyp: routergeraettyp): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setListLoading(true));
  putWithAuth("ROUTERTYPID", {}, aktuellesRoutergeraettyp, aktuellesRoutergeraettyp.id.toString())
    .then(() => {
      dispatch(
        openSnackbar({
          message: `Routergerättyp ${aktuellesRoutergeraettyp.typ} wurde erfolgreich geändert.`,
          severity: "success",
          duration: 6000,
        })
      );
      dispatch(setAltesRoutergeraettyp(aktuellesRoutergeraettyp));
      dispatch(updateRoutergeraettypen(aktuellesRoutergeraettyp));
      dispatch(resetEditEntry());
      dispatch(resetNewEntry());
      dispatch(resetEditDirty());
    }
    )
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));

};

export const updateAktuellesRoutergeraettyp = (aktuellesRoutergeraettyp: routergeraettyp): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setAktuellesRoutergeraettyp(aktuellesRoutergeraettyp));
  dispatch(setViewMode());
};

export const discardChanges = () => (dispatch: AppDispatch): void => {
  dispatch(resetAktuellesRoutergeraettyp());
  dispatch(resetEditEntry());
  dispatch(resetNewEntry());
  dispatch(resetEditDirty());
};

export const discardNew = () => (dispatch: AppDispatch): void => {
  dispatch(resetAktuellesRoutergeraettyp());
  dispatch(resetEditEntry());
  dispatch(resetNewEntry());
  dispatch(resetEditDirty());
  dispatch(resetViewMode());
};

export const startNewEntry = () => (dispatch: AppDispatch): void => {
  dispatch(setNewEntry());
  dispatch(setAktuellesRoutergeraettyp(routergeraettypDummy));
  dispatch(setEditEntry());
  dispatch(setViewMode());
};

export const createRoutergeraettyp = (aktuellesRoutergeraettyp: routergeraettyp): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setListLoading(true));
  postJsonWithAuth("ROUTERTYP", {}, {
    id: aktuellesRoutergeraettyp.id,
    typ: aktuellesRoutergeraettyp.typ,
    hersteller: aktuellesRoutergeraettyp.hersteller,
    kommentar: aktuellesRoutergeraettyp.kommentar,
    zugeordnet: aktuellesRoutergeraettyp.zugeordnet
  })
    .then((response) => {
      dispatch(
        openSnackbar({
          message: `Routergerättyp ${aktuellesRoutergeraettyp.typ} wurde erfolgreich angelegt.`,
          severity: "success",
          duration: 6000,
        })
      );
      dispatch(setIdAktuellesRoutergeraettyp(response));
      dispatch(addAktuellesRoutergeraettypToRoutergeraettypen());
      dispatch(setAktuellesRoutergeraettyp(routergeraettypDummy));
      dispatch(resetEditEntry());
      dispatch(resetNewEntry());
      dispatch(resetEditDirty());
      dispatch(resetViewMode());
    }
    )
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));

};

export const deleteRoutergeraettyp = (aktuellesRoutergeraettyp: routergeraettyp): ThunkAction<void, RootState, unknown, AnyAction> => (
  dispatch: AppDispatch
) => {
  dispatch(setListLoading(true));
  deleteWithAuth("ROUTERTYPID", { id: aktuellesRoutergeraettyp.id }, aktuellesRoutergeraettyp.id.toString())
    .then(() => {
      dispatch(setAktuellesRoutergeraettyp(routergeraettypDummy));
      dispatch(removeFromRoutergeraettypen(aktuellesRoutergeraettyp));
      dispatch(resetEditEntry());
      dispatch(resetEditDirty());
      dispatch(resetViewMode());
      dispatch(openSnackbar({
        message: `Routertyp ${aktuellesRoutergeraettyp.typ} wurde erfolgreich gelöscht.`,
        severity: "success",
        duration: 6000,
      }));
    }
    )
    .catch((error) => {
      logError(error);
      errorHandler(error, dispatch);
    }).finally(() => dispatch(setListLoading(false)));
};

export const {
  removeFromRoutergeraettypen,
  setRoutergeraettypen,
  setAktuellesRoutergeraettyp,
  resetAktuellesRoutergeraettyp,
  setAltesRoutergeraettyp,
  updateRoutergeraettypen,
  setEditEntry,
  resetEditEntry,
  setNewEntry,
  resetNewEntry,
  resetEditDirty,
  setViewMode,
  resetViewMode,
  setError,
  resetError,
  setTyp,
  setHersteller,
  setId,
  setKommentar,
  setIdAktuellesRoutergeraettyp,
  addAktuellesRoutergeraettypToRoutergeraettypen,
  setListLoading,
  setSorting
} = routergeraettypenSlice.actions;
export default routergeraettypenSlice.reducer;